// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.domestic-type-approval-container {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 100px;
  background-color: #fff;
  border-radius: 8px;
  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);
  gap: 20px;
}

.domestic-type-approval-text {
  width: 50%;
  order: 1;
  margin-top: -35px;
}

.domestic-type-approval-text h1 {
  font-size: 2em;
  color: #000;
  margin-bottom: 10px;
}

.domestic-type-approval-text h2 {
  font-size: 1.5em;
  color: #555;
  margin-top: 20px;
  margin-bottom: 10px;
}

.domestic-type-approval-text p {
  font-size: 1em;
  color: #555;
  margin-bottom: 10px;
}

.services-list {
  list-style: none;
  padding: 0;
  margin-top: 10px;
}

.services-list li {
  font-size: 0.9em;
  color: #333;
  margin-bottom: 10px;
}

.domestic-type-approval-image {
  position: relative;
  width: 85%;
  height: 100%;
  order: 2;
  margin-top: 50px;
}

@media (max-width: 768px) {
  .domestic-type-approval-container {
    flex-direction: column;
    align-items: center;
    text-align: left;
    gap: 20px;
  }

  .domestic-type-approval-text {
    width: 170%;
    order: 1;
  }

  .domestic-type-approval-image {
    width: 100%;
    order: 2;
  }

  .services-list li {
    width: 100%;
  }
  .domestic-type-approval-image {
    position: relative;
    width: 180%;
    order: 1;
  }

  .services-image {
    width: 100%;
    height: auto;
    border-radius: 8px;
  }
}
@media (min-width: 1366px) and (max-width: 1366px) {
  .domestic-type-approval-container {
    padding: 80px;
  }

  .domestic-type-approval-text {
    width: 55%;
  }

  .domestic-type-approval-image {
    width: 37%;
  }

  .services-list li {
    width: 48%;
  }
  .services-image {
    width: 110%;
    height: auto;
    border-radius: 8px;
  }
}

@media (min-width: 1920px) and (max-width: 1920px) {
  .domestic-type-approval-container {
    padding: 120px;
  }

  .domestic-type-approval-text {
    width: 58%;
  }

  .domestic-type-approval-image {
    width: 38%;
  }

  .services-list li {
    width: 40%;
  }
}

@media (min-width: 1380px) and (max-width: 1919px) {
  .domestic-type-approval-container {
    padding: 100px;
  }

  .domestic-type-approval-text {
    width: 59%;
  }

  .domestic-type-approval-image {
    width: 30%;
  }

  .services-list li {
    width: 44%;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/DomesticTypeApproval/DomesticTypeApproval.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,cAAc;EACd,sBAAsB;EACtB,kBAAkB;EAClB,wCAAwC;EACxC,SAAS;AACX;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,QAAQ;EACR,gBAAgB;AAClB;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;EACX;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;EACb;EACA;IACE,kBAAkB;IAClB,WAAW;IACX,QAAQ;EACV;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;AACA;EACE;IACE,aAAa;EACf;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;EACA;IACE,WAAW;IACX,YAAY;IACZ,kBAAkB;EACpB;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF;;AAEA;EACE;IACE,cAAc;EAChB;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;;EAEA;IACE,UAAU;EACZ;AACF","sourcesContent":[".domestic-type-approval-container {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 100px;\n  background-color: #fff;\n  border-radius: 8px;\n  box-shadow: 0 4px 8px rgba(0, 0, 0, 0.1);\n  gap: 20px;\n}\n\n.domestic-type-approval-text {\n  width: 50%;\n  order: 1;\n  margin-top: -35px;\n}\n\n.domestic-type-approval-text h1 {\n  font-size: 2em;\n  color: #000;\n  margin-bottom: 10px;\n}\n\n.domestic-type-approval-text h2 {\n  font-size: 1.5em;\n  color: #555;\n  margin-top: 20px;\n  margin-bottom: 10px;\n}\n\n.domestic-type-approval-text p {\n  font-size: 1em;\n  color: #555;\n  margin-bottom: 10px;\n}\n\n.services-list {\n  list-style: none;\n  padding: 0;\n  margin-top: 10px;\n}\n\n.services-list li {\n  font-size: 0.9em;\n  color: #333;\n  margin-bottom: 10px;\n}\n\n.domestic-type-approval-image {\n  position: relative;\n  width: 85%;\n  height: 100%;\n  order: 2;\n  margin-top: 50px;\n}\n\n@media (max-width: 768px) {\n  .domestic-type-approval-container {\n    flex-direction: column;\n    align-items: center;\n    text-align: left;\n    gap: 20px;\n  }\n\n  .domestic-type-approval-text {\n    width: 170%;\n    order: 1;\n  }\n\n  .domestic-type-approval-image {\n    width: 100%;\n    order: 2;\n  }\n\n  .services-list li {\n    width: 100%;\n  }\n  .domestic-type-approval-image {\n    position: relative;\n    width: 180%;\n    order: 1;\n  }\n\n  .services-image {\n    width: 100%;\n    height: auto;\n    border-radius: 8px;\n  }\n}\n@media (min-width: 1366px) and (max-width: 1366px) {\n  .domestic-type-approval-container {\n    padding: 80px;\n  }\n\n  .domestic-type-approval-text {\n    width: 55%;\n  }\n\n  .domestic-type-approval-image {\n    width: 37%;\n  }\n\n  .services-list li {\n    width: 48%;\n  }\n  .services-image {\n    width: 110%;\n    height: auto;\n    border-radius: 8px;\n  }\n}\n\n@media (min-width: 1920px) and (max-width: 1920px) {\n  .domestic-type-approval-container {\n    padding: 120px;\n  }\n\n  .domestic-type-approval-text {\n    width: 58%;\n  }\n\n  .domestic-type-approval-image {\n    width: 38%;\n  }\n\n  .services-list li {\n    width: 40%;\n  }\n}\n\n@media (min-width: 1380px) and (max-width: 1919px) {\n  .domestic-type-approval-container {\n    padding: 100px;\n  }\n\n  .domestic-type-approval-text {\n    width: 59%;\n  }\n\n  .domestic-type-approval-image {\n    width: 30%;\n  }\n\n  .services-list li {\n    width: 44%;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
